app.service('articleVotes', function (localStorage, modal, simpleToastr, loading, validate) {
	let linkname;
	let $articleVotesBlock, $articleVote;
	let $voteUpOpenModalButton, $voteDownReasonButton, $emailAgreement;
	const timeToChange = 1000 * 60 * 15; //15 minut

	function updateVotesPresentation(voteName, newVote, previousVote) {
		if (newVote === '') {
			// odznaczenie tego samego głosu
			markVote({ vote: voteName, state: 0 });
		} else {
			// zaznaczenie głosu
			markVote({ vote: voteName, state: 1 });
			if (previousVote != '') {
				// odznaczenie przeciwnego głosu
				markVote({ vote: previousVote, state: -1 });
			}
		}
	}
	function markVote(params) {
		const { vote, state } = params;
		// vote ->  rodzaj głosu - kciuk w górę / kciuk w dół (UP/DOWN)
		// state -> 1 dla oddanego głosu, 0 wartość głosu bez zmian, undefined - tylko kolorujemy kciuk
		const $voteToMark = $articleVotesBlock.find('[data-article-vote="' + vote + '"]');
		const voteCurrentValue = $voteToMark.first().data('article-vote-value');
		const updatedVoteValue = state != undefined ? voteCurrentValue + state : voteCurrentValue;
		$voteToMark.text('(' + (updatedVoteValue < 0 ? 0 : updatedVoteValue) + ')');
		$articleVotesBlock.attr('data-vote', vote);
		if (state === 1 || state === undefined) {
			$articleVote.removeClass('voted');
			$voteToMark.addClass('voted');
		}
		if (state === 0) {
			$voteToMark.removeClass('voted');
		}
	}
	function disableVoting() {
		$articleVote.addClass('disabled');
	}
	function setLocalData(newVote) {
		const votesLocalData = getLocalData();
		const voteData = votesLocalData[linkname];
		const currentTimeStamp = new Date().valueOf();
		let voteTimeOutStamp = currentTimeStamp + timeToChange;
		let firstVote = ''; // pierwszy oddany głos
		let blocked = false;
		let clicks = 0;
		if (voteData) {
			if (typeof voteData === 'string') {
				// kompatybilność z poprzednią wersją, gdzie zapisywane były tylko stringi
				// traktujemy jako głosy z przekroczonym czasem i od razu blokujemy możliwość głosowania
				firstVote = voteData.toUpperCase();
				blocked = true;
			} else {
				if (voteData.thumb != undefined) {
					// pobranie wartości dla nowej struktury
					firstVote = voteData.thumb ? voteData.thumb : voteData.firstThumb ? voteData.firstThumb : '';
					voteTimeOutStamp = voteData.voteTimeOutStamp ? voteData.voteTimeOutStamp : voteTimeOutStamp;
					blocked = voteData.blocked ? voteData.blocked : false;
					clicks = voteData.clicks != undefined ? voteData.clicks : clicks;

					if (newVote === undefined || voteTimeOutStamp < currentTimeStamp && voteData.thumb === '' && clicks > 1) {
						// reset, jakby głos nie był jeszcze oddawany
						voteTimeOutStamp = currentTimeStamp + timeToChange; // odnowienie czasu na zmianę głosu
						firstVote = '';
						clicks = newVote === undefined ? 0 : 1;
					}
					if (newVote != undefined) {
						clicks += 1;
					}
					if (!blocked && newVote != '' && firstVote != '' || clicks > 2) {
						// nastąpiła zmiana głosu bezpośrednio z jednego na drugi, więc blokada całkowita głosowania
						// lub gdy głos został zmieniony po raz 3 w ciągu 15 minut
						blocked = true;
						disableVoting();
						markVote({ vote: newVote });
					}
				}
			}
		} else {
			clicks = 1;
		}

		votesLocalData[linkname] = {
			thumb: newVote,
			firstThumb: firstVote,
			voteTimeOutStamp: voteTimeOutStamp,
			blocked: blocked,
			clicks: clicks
		}
		localStorage.setItem('articleVoteNew', JSON.stringify(votesLocalData));
	}
	function getLocalData() {
		var v = localStorage.getItem('articleVoteNew') || "{}";
		return JSON.parse(v);
	}
	function getPreviousVoute() {
		let voteData = getLocalData()[linkname];
		return voteData && voteData.thumb ? voteData.thumb.toUpperCase() : '';
	}
	function checkVoteAvailable() {
		const voteData = getLocalData()[linkname];
		let availableToVote = true;
		let viewCached = false;
		if (voteData) {
			if (typeof voteData === 'string') {
				// przepisanie danych z poprzedniego formatu do nowego przy pierwszym wejściu na widok artykułu
				setLocalData(voteData.toUpperCase());
			}
			if (voteData.voteTimeOutStamp) {
				const maxTimeToVote = voteData.voteTimeOutStamp; // czas oddania głosu powiększony o 15min
				const currentTime = new Date().valueOf();
				if (maxTimeToVote < currentTime && voteData.thumb != '') {
					// jeżeli czas oddania głosu został przekroczony, a oddano głos to blokujemy możliwość głosowania
					availableToVote = false;
				}
				if (maxTimeToVote < currentTime && voteData.thumb == '' && voteData.clicks > 1) {
					// jeżeli czas oddania głosu został przekroczony, a wcześniej odznaczono głos to resetujemy dane w storage i pozwalamy głosować od początku
					setLocalData();
					availableToVote = true;
				}
				if (maxTimeToVote > currentTime) {
					// pokazujemy zwiększoną wartość dla kciuka przez JS do czasu wymiany cache (poźniej przyjdzie już z BE)
					viewCached = true;
				}
			}
			if (voteData.blocked) {
				availableToVote = false;
			}
			if (availableToVote === false) {
				disableVoting();
			}
			if (voteData.thumb) {
				markVote({
					vote: voteData.thumb,
					state: viewCached ? 1 : undefined
				});
			}
		}
	}

	function saveVote(voteName) {
		const previousVote = getPreviousVoute(); // '', 'UP, 'DOWN' (ostatnio oddany głos z localstorage)
		const newVote = previousVote === voteName ? '' : voteName;

		if (voteName == 'UP' || newVote == '') {
			loading.start();
			$.ajax({
				url: '/article-add-vote.ltr',
				type: 'POST',
				data: {
					articleLink: linkname,
					thumb: newVote,
					previousThumb: previousVote
				},
				success: function () {
					setLocalData(newVote);
					updateVotesPresentation(voteName, newVote, previousVote);
					loading.stop();
					if (newVote == 'UP') {
						simpleToastr.open('article-vote-up-success');
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd dodawania opinii o artykule. Prosimy spróbować później.');
				}
			});
		} else if (voteName == 'DOWN') {
			modal.open('article-vote-down');
		}
	}

	function sendForm($form, voteName) {
		let url = '';
		let data = $form.serializeArray();
		const previousVote = getPreviousVoute();
		const newVote = previousVote === voteName ? '' : voteName;
		if (voteName == 'UP') {
			url = '/article-add-positive-opinion.ltr';
		} else {
			url = '/article-add-vote.ltr';
			data.push(...[
				{
					name: 'thumb',
					value: newVote,
				},
				{
					name: 'previousThumb',
					value: previousVote,
				}
			]);
		}

		loading.start();

		$.ajax({
			url: url,
			data: data,
			method: 'POST',
			success: function (json) {
				loading.stop();
				if (json.status == 'SUCCESS') {
					modal.close();
					simpleToastr.open('article-vote-form-success');
					if (voteName === 'DOWN') {
						setLocalData(voteName);
						updateVotesPresentation(voteName, newVote, previousVote);
					}
				} else {
					json.messages != '' ? modal.alert(json.messages[0]) : modal.alert('Wystapił błąd wysyłania formularza opinii o artykule. Prosimy spróbować później');
				}
			}, error: function () {
				loading.stop();
				modal.alert('Wystapił błąd wysyłania formularza opinii o artykule. Prosimy spróbować później');
			}
		});
	}

	function setElements() {
		$articleVotesBlock = $('.article-votes-block');
		$articleVote = $('.js-article-vote');
		linkname = $articleVotesBlock.data('linkname');

		$voteUpOpenModalButton = $('.js-open-article-vote-up-modal'); //button on toastr for positive vote
		$voteDownReasonButton = $('.js-vote-down-reason'); //modal negative vote

		$emailAgreement = $('.email-agreement input[type="checkbox"]'); //email-agreement checkbox on modal
	}

	function setEvents() {
		$voteUpOpenModalButton.on('click', function () {//button on toastr for positive vote
			modal.open('article-vote-up');
		});

		$voteDownReasonButton.on('click', function () {//modal on negative vote
			$voteDownReasonButton.removeClass('selected');
			$(this).addClass('selected');
			$('#vote-down-reason').val($(this).text())
			$voteDownReasonButton.filter('.selected').length > 0 ? $('.vote-down-additional-section').addClass('show') : $('.vote-down-additional-section').removeClass('show');
		});

		$emailAgreement.on('change', function () {//email-agreement checkbox on modals
			var $agreementElements = $(this).closest('form').find('.email-row, .permissions-disclaimer');

			if ($(this).is(':checked')) {
				$(this).val(true);
				$agreementElements.addClass('show');
			} else {
				$(this).val(false);
				$agreementElements.removeClass('show');
			}
		});

		validate.task('articleVoteUpForm', function (form) {
			sendForm(form, 'UP');
		});
		validate.task('articleVoteDownForm', function (form) {
			sendForm(form, 'DOWN');
		});

		checkVoteAvailable();

		$articleVote.on('click', function () {
			if ($(this).hasClass('disabled')) {
				if (!simpleToastr.isOpen('article-vote-already-voted')) {
					simpleToastr.open('article-vote-already-voted');
				}
			} else {
				saveVote($(this).data('article-vote'));
			}
		});
	}

	function init() {
		simpleToastr.init();
		setElements();
		setEvents();
	}

	return {
		init: init
	};
});
